import { useState } from 'react';
import phone from '../photo/phone.png';
import email from '../photo/email.png';
import location from '../photo/location.png';
import facebook from '../photo/facebook.png';
import whatsapp from '../photo/whatsapp.png';
import instagram from '../photo/instagram.png';
import "../styles/contact.css";

export function Contact() {
    const [activeModal, setActiveModal] = useState(null);

    const closeModal = () => setActiveModal(null);

    const renderModal = () => {
        if (!activeModal) return null;

        const content = {
            privacy: {
                title: "Politique de Confidentialité",
                sections: [
                    { subtitle: "1. Collecte des données", text: "Nous collectons des informations telles que votre nom, adresse e-mail, adresse de livraison et numéro de téléphone lorsque vous passez une commande." },
                    { subtitle: "2. Utilisation des données", text: "Vos informations sont utilisées exclusivement pour traiter vos commandes, améliorer notre service client et vous envoyer des mises à jour sur vos achats." },
                    { subtitle: "3. Sécurité", text: "Nous mettons en œuvre des mesures de sécurité avancées pour protéger vos données personnelles contre tout accès non autorisé." },
                    { subtitle: "4. Vos droits", text: "Conformément à la loi 09-08, vous disposez d'un droit d'accès, de rectification et d'opposition au traitement de vos données personnelles." }
                ]
            },
            terms: {
                title: "Conditions d'Utilisation",
                sections: [
                    { subtitle: "1. Acceptation", text: "En utilisant ce site, vous acceptez nos conditions générales. Si vous n'êtes pas d'accord, veuillez ne pas utiliser nos services." },
                    { subtitle: "2. Propriété Intellectuelle", text: "Tout le contenu présent sur Jamas Lens (textes, images, logos) est la propriété exclusive de l'entreprise." },
                    { subtitle: "3. Commandes", text: "Toute commande passée sur le site est ferme et définitive après validation du paiement ou confirmation par notre équipe." },
                    { subtitle: "4. Responsabilité", text: "Jamas Lens ne saurait être tenu responsable des dommages indirects résultant de l'utilisation de ses produits." }
                ]
            },
            shipping: {
                title: "Politique de Livraison",
                sections: [
                    { subtitle: "1. Zones de livraison", text: "Nous livrons dans toutes les villes du Maroc: Casablanca, Rabat, Marrakech, Tanger, Agadir, etc." },
                    { subtitle: "2. Délais", text: "Le délai moyen est de 24h à 48h pour les centres urbains et jusqu'à 5 jours pour les zones isolées." },
                    { subtitle: "3. Frais de port", text: "Les frais de livraison sont calculés selon le poids de la commande et la zone géographique." },
                    { subtitle: "4. Vérification", text: "Il est impératif de vérifier l'état du colis en présence du livreur avant de signer le bon de réception." }
                ]
            }
        }[activeModal];

        return (
            <div className="policy-modal-overlay" onClick={closeModal}>
                <div className="policy-modal-content" onClick={e => e.stopPropagation()}>
                    <button className="close-modal-btn" onClick={closeModal}>&times;</button>
                    <div className="policy-modal-header">
                        <h3>{content.title}</h3>
                        <div className="header-line"></div>
                    </div>
                    <div className="modal-body scrollable">
                        {content.sections.map((sec, i) => (
                            <div key={i} className="modal-section">
                                <h5>{sec.subtitle}</h5>
                                <p>{sec.text}</p>
                            </div>
                        ))}
                    </div>
                    <div className="modal-footer">
                        <button className="confirm-btn" onClick={closeModal}>J'ai compris</button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <section className="contact-section-wrapper">
            <div className="contact-main-grid">
                {/* Brand / About */}
                <div className="contact-col">
                    <h4>À Propos</h4>
                    <p>
                        Jamas Lens est votre partenaire de confiance spécialisé dans la vente de
                        climatiseurs et la réalisation de projets de construction publique.
                        Qualité et innovation au service de votre confort.
                    </p>
                </div>

                {/* Navigation */}
                <div className="contact-col">
                    <h4>Navigation</h4>
                    <ul className="footer-nav">
                        <div className="footer-nav-container">
                            <div className="footer-nav-left">
                                <li><a href="/">Accueil</a></li>
                                <li><a href="/listeClimatisseurs">Climatiseurs</a></li>
                            </div>
                            <div className="footer-nav-right">
                                <li><a href="/listeProjets">Projets</a></li>
                                <li><a href="/panier">Panier</a></li>
                            </div>
                        </div>
                    </ul>
                </div>

                {/* Legal Section */}
                <div className="contact-col">
                    <h4>Légal</h4>
                    <ul className="footer-nav">
                        <li><span className="legal-link" onClick={() => setActiveModal('privacy')}>Politique de Confidentialité</span></li>
                        <li><span className="legal-link" onClick={() => setActiveModal('terms')}>Conditions d'Utilisation</span></li>
                        <li><span className="legal-link" onClick={() => setActiveModal('shipping')}>Politique de Livraison</span></li>
                    </ul>
                </div>

                {/* Contact Details */}
                <div className="contact-col">
                    <h4>Contact</h4>
                    <div className="contact-detail">
                        <img src={location} alt="Address" />
                        <span>Casablanca, Maroc</span>
                    </div>
                    <div className="contact-detail">
                        <img src={phone} alt="Phone" />
                        <span>+212 5XX XXXXXX</span>
                    </div>
                    <div className="contact-detail">
                        <img src={email} alt="Email" />
                        <span>contact@jamaslens.ma</span>
                    </div>
                </div>
            </div>

            {/* Social Follow Section */}
            <div className="footer-social-follow">
                <p>Suivez-nous</p>
                <div className="social-box">
                    <a href="https://facebook.com" target="_blank" className="social-circle">
                        <img src={facebook} alt="Facebook" />
                    </a>
                    <a href="https://wa.me/212675349447" target="_blank" className="social-circle">
                        <img src={whatsapp} alt="WhatsApp" />
                    </a>
                    <a href="https://instagram.com" target="_blank" className="social-circle">
                        <img src={instagram} alt="Instagram" />
                    </a>
                </div>
            </div>

            <div className="footer-bottom-line">
                <p>&copy; 2026 Jamas Lens. Tous droits réservés.</p>
            </div>

            {renderModal()}
        </section>
    );
}


